import { useTranslation } from "react-i18next";
import "./Footer.css";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <img src="/niertech-logo.svg" alt="" className="footer__logo" />
          <div>
            <span className="footer__name">Niertech Solutions</span>
            <span className="footer__legal">{t("footer.company_legal")}</span>
          </div>
        </div>

        <div className="footer__meta">
          <span>{t("footer.copyright", { year: new Date().getFullYear() })}</span>
          <span className="footer__dot">·</span>
          <span>{t("footer.city")}</span>
        </div>
      </div>
    </footer>
  );
}
